import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ToastResponse } from '../../utilities/ToastResponse';
import { SliderContentCreate } from '../../services';

export const fetchSliderContentCreate = createAsyncThunk(
    'sliderContentCreate/fetchSliderContentCreate',
    async ({ file, title, slug, sliderId, sort }) => {
        const response = await SliderContentCreate(file, title, slug, sliderId, sort)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const sliderContentCreateSlice = createSlice({
    name: 'sliderContentCreate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSliderContentCreate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSliderContentCreate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSliderContentCreate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default sliderContentCreateSlice.reducer;
